
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import BillSearch from './BillSearch';
import BillsTable from './BillsTable';
import { Bill } from './types';

interface BillsTabsProps {
  bills: Bill[];
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onPayNow: (bill: Bill) => void;
  showPaymentForm: boolean;
  selectedBill: Bill | null;
  handlePaymentComplete: () => void;
  setShowPaymentForm: (show: boolean) => void;
}

const BillsTabs = ({ 
  bills, 
  searchTerm, 
  setSearchTerm, 
  activeTab, 
  setActiveTab, 
  onPayNow,
  showPaymentForm,
  selectedBill,
  handlePaymentComplete,
  setShowPaymentForm
}: BillsTabsProps) => {
  
  const filteredBills = bills.filter(bill => {
    return bill.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
           bill.month.toLowerCase().includes(searchTerm.toLowerCase()) ||
           bill.status.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <Card className="border-gray-200 dark:border-gray-800 shadow-sm">
      <CardHeader className="px-6 py-4 flex flex-row items-center justify-between border-b border-gray-200 dark:border-gray-800">
        <CardTitle className="text-lg font-semibold text-gray-900 dark:text-white">Utility Bills</CardTitle>
        <div className="flex items-center space-x-2">
          <BillSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
      </CardHeader>
      <CardContent className="px-0 py-0">
        <Tabs defaultValue="current" value={activeTab} onValueChange={setActiveTab}>
          <div className="px-6 py-4">
            <TabsList className="grid w-full grid-cols-3 mb-6 bg-gray-100 dark:bg-gray-800">
              <TabsTrigger value="current" className="text-gray-700 dark:text-gray-300 data-[state=active]:text-gray-900 data-[state=active]:dark:text-white">Current</TabsTrigger>
              <TabsTrigger value="history" className="text-gray-700 dark:text-gray-300 data-[state=active]:text-gray-900 data-[state=active]:dark:text-white">History</TabsTrigger>
              <TabsTrigger value="all" className="text-gray-700 dark:text-gray-300 data-[state=active]:text-gray-900 data-[state=active]:dark:text-white">All Bills</TabsTrigger>
            </TabsList>
          </div>
          
          <TabsContent value="current" className="m-0">
            <BillsTable 
              bills={filteredBills} 
              activeTab="current" 
              onPayNow={onPayNow} 
            />
          </TabsContent>
          
          <TabsContent value="history" className="m-0">
            <BillsTable 
              bills={filteredBills} 
              activeTab="history" 
              onPayNow={onPayNow} 
            />
          </TabsContent>
          
          <TabsContent value="all" className="m-0">
            <BillsTable 
              bills={filteredBills} 
              activeTab="all" 
              onPayNow={onPayNow} 
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default BillsTabs;
